import PropTypes from 'prop-types';

const MiddleMenuPropType = {
  children: PropTypes.node,
};

export default MiddleMenuPropType;
